import { render, staticRenderFns } from "./CustomCheckboxFilter.vue?vue&type=template&id=609a886f&scoped=true"
import script from "./CustomCheckboxFilter.vue?vue&type=script&lang=ts"
export * from "./CustomCheckboxFilter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609a886f",
  null
  
)

export default component.exports